import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SwapDetails.css';

const SwapDetails: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleSwapMore = () => {
    navigate('/swap');
  };

  const handleWithdrawNow = () => {
    navigate('/withdraw');
  };

  const handleCopyTransactionId = () => {
    navigator.clipboard.writeText('A09381640483');
  };

  return (
    <div className="app-container">
      <div className="mobile-frame">
        <div className="mobile-notch"></div>
        <div className="mobile-screen">
          <div className="swap-details-container">
            {/* Header */}
            <header className="swap-details-header">
              <button className="swap-details-back-button" onClick={handleBack} aria-label="Go back">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h1 className="swap-details-header-title">Transaction details</h1>
            </header>

            <div className="swap-details-content">
              {/* Success Icon */}
              <div className="swap-details-icon-wrapper">
                <div className="swap-details-icon-bg">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M8 14L12 18L20 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>

              {/* Status Badge */}
              <div className="swap-details-status-badge">
                Completed
              </div>

              {/* Amount */}
              <div className="swap-details-amount">
                2 USDT
              </div>

              {/* Transaction Details Card */}
              <div className="swap-details-card">
                <div className="swap-details-card-header">
                  <span className="swap-details-card-label">Swap</span>
                  <div className="swap-details-crypto-pair">
                    <div className="swap-details-crypto-icon swap-details-crypto-icon-usdt"></div>
                    <span className="swap-details-crypto-text">USDT</span>
                    <span className="swap-details-arrow">→</span>
                    <div className="swap-details-crypto-icon swap-details-crypto-icon-btc"></div>
                    <span className="swap-details-crypto-text">BTC</span>
                  </div>
                </div>

                <div className="swap-details-row">
                  <span className="swap-details-label">Transaction ID</span>
                  <div className="swap-details-value-with-copy">
                    <span className="swap-details-value">A09381640483</span>
                    <button className="swap-details-copy-button" onClick={handleCopyTransactionId} aria-label="Copy transaction ID">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M11 5V3.5C11 2.67157 10.3284 2 9.5 2H3.5C2.67157 2 2 2.67157 2 3.5V9.5C2 10.3284 2.67157 11 3.5 11H5" stroke="currentColor" strokeWidth="1.5"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="swap-details-row">
                  <span className="swap-details-label">Order opening time</span>
                  <span className="swap-details-value">05/11/2025 - 08:42:37</span>
                </div>

                <div className="swap-details-row">
                  <span className="swap-details-label">Order matching time</span>
                  <span className="swap-details-value">05/11/2025 - 08:42:37</span>
                </div>

                <div className="swap-details-divider"></div>

                <div className="swap-details-row">
                  <span className="swap-details-label">From</span>
                  <span className="swap-details-value">2 USDT</span>
                </div>

                <div className="swap-details-row">
                  <span className="swap-details-label">Market price</span>
                  <span className="swap-details-value">101,733.8 USDT/BTC</span>
                </div>

                <div className="swap-details-row">
                  <span className="swap-details-label">You get</span>
                  <div className="swap-details-value-with-icon">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 1L9 5L13 6L10 9L10.5 13L7 11L3.5 13L4 9L1 6L5 5L7 1Z" fill="#22C35E"/>
                    </svg>
                    <span className="swap-details-value">0.00001961 BTC</span>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="swap-details-actions">
                <button className="swap-details-button-secondary" onClick={handleSwapMore}>
                  Swap more
                </button>
                <button className="swap-details-button-primary" onClick={handleWithdrawNow}>
                  Withdraw now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwapDetails;